import gql from "graphql-tag";

export const CREATE_USER_MUTATION = gql`
  mutation($params: UserParams!) {
    createUser(params: $params) {
      id
    }
  }
`;

export const UPDATE_USER_MUTATION = gql`
  mutation($id: Int!, $params: UserParams!) {
    updateUser(id: $id, params: $params) {
      id
    }
  }
`;

export const DELETE_USER_MUTATION = gql`
  mutation($id: Int!) {
    deleteUser(id: $id) {
      id
    }
  }
`;

export const ASSIGN_AUTOMATION_OPERATOR_MUTATION = gql`
  mutation($userId: Int!) {
    assignAutomationOperator(userId: $userId) {
      id
      name
    }
  }
`;

export const CLEAR_AUTOMATION_OPERATOR_MUTATION = gql`
  mutation {
    clearAutomationOperator
  }
`;
